<template lang="html">
  <div class="container-flude">
    <div class="row">
      <div class="col-md-12 d-flex align-items-center justify-content-center flex-column" style="min-height: 100vh">
        <h1 class="h1 my-3 text-light">Not Found</h1>
        <h2 class="h1 my-3 text-light">404</h2>
      </div>
    </div>
  </div>
</template>

<script>
export default {
}
</script>

<style lang="css" scoped>
.container-flude{
  background: linear-gradient(45deg, #22466c, #222) !important;
}
</style>
